// import VueGridLayout from 'vue-grid-layout';
// import { createApp } from 'vue';

// import { vueGrid } from './vuecomponents/vuegrid.vue'
 

export class FolderView {
    constructor() {

        // const app = createApp({
        //   data() {
        //     return {
        //       count: 0
        //     }
        //   }
        // })
        // app.component('vueGrid', vueGrid)

        // app.mount('#folder-view-vue')

        $(document).on('click', '.folder-view .item', e => {
            e.preventDefault()

            const $a = $(e.currentTarget)

            $('.folder-view .item').removeClass('selected')

            $a.toggleClass('selected')

        })

        $(document).on('dblclick', '.folder-view .item[data-clickable]', e => {
            e.preventDefault()
            const $a = $(e.currentTarget)

            $('.folder-view .item').removeClass('selected')

            // $a.toggleClass('selected')

            let href = $a.attr('data-clickable-url')

            document.location.href = href

            return false

        })


         //Events for desktop and touch
        let events = ["contextmenu", "touchstart"];

        //initial declaration
        var timeout;

        //for double tap
        var lastTap = 0;

        //refer menu div
        let contextMenu = document.getElementById('context-menu');

        //same function for both events
        //event type is a data structure that defines the data contained in an event
            events.forEach((eventType) => {
              document.addEventListener(
                eventType,
                (e) => {

                    $('#context-menu').html('')

                    // console.log($(e.target.parentElement).parents('.folder-view').length || $(e.target.parentElement).hasClass('folder-view'))

                    // if ( ! $(e.target.parentElement).hasClass('item') ) {
                    if ( ( ! $(e.target.parentElement).hasClass('item') ) && ( $(e.target.parentElement).parents('.folder-view').length || $(e.target.parentElement).hasClass('folder-view') ) ) {
                        e.preventDefault()
                        return false
                    } else if (! $(e.target.parentElement).hasClass('item') )  return
 
                    const item = $(e.target.parentElement)
                    // alert($('.context-menu-content', item).length)
                    $('.folder-view .item').removeClass('selected')
                    item.addClass('selected')
                    if ( ! $('.context-menu-content', item).length ) {

                        e.preventDefault()
                        return false;
                    }

                    $('.context-menu-content .context-menu-item', item).each(function() {
                        let $el = $(this),
                            name = $el.text(),
                            url = $el.data('click-url')
                        $('#context-menu').append( `<a class="context-menu-item" href="${url}">${name}</a>` )
                    })
                    

                    //preventDefault() method stops the default action of a selected element from happening by a user
                    e.preventDefault();
                    //x and y position of mouse or touch
                    //mouseX represents the x-coordinate of the mouse
                    let mouseX = e.clientX || e.touches[0].clientX;
                    //mouseY represents the y-coordinate of the mouse.
                    let mouseY = e.clientY || e.touches[0].clientY;
                    //height and width of menu
                    //getBoundingClientRect() method returns the size of an element and its position relative to the viewport
                    let menuHeight = contextMenu.getBoundingClientRect().height;
                    let menuWidth = contextMenu.getBoundingClientRect().width;
                    //width and height of screen
                    //innerWidth returns the interior width of the window in pixels
                    let width = window.innerWidth;
                    let height = window.innerHeight;
                    //If user clicks/touches near right corner
                    if (width - mouseX <= 200) {
                        contextMenu.style.borderRadius = "5px 0 5px 5px";
                        contextMenu.style.left = width - menuWidth + "px";
                        contextMenu.style.top = mouseY + "px";
                        //right bottom
                        if (height - mouseY <= 200) {
                        contextMenu.style.top = mouseY - menuHeight + "px";
                        contextMenu.style.borderRadius = "5px 5px 0 5px";
                        }
                    }
                    //left
                        else {
                        contextMenu.style.borderRadius = "0 5px 5px 5px";
                        contextMenu.style.left = mouseX + "px";
                        contextMenu.style.top = mouseY + "px";
                        //left bottom
                        if (height - mouseY <= 200) {
                            contextMenu.style.top = mouseY - menuHeight + "px";
                            contextMenu.style.borderRadius = "5px 5px 5px 0";
                        }
                    }
                    //display the menu
                    contextMenu.style.visibility = "visible";
                },
                { passive: false }
              );
            });

            //for double tap(works on touch devices)
            document.addEventListener("touchend", function (e) {
              //current time
              var currentTime = new Date().getTime();
              //gap between two gaps
              var tapLength = currentTime - lastTap;
              //clear previous timeouts(if any)
        //The clearTimeout() method clears a timer set with the setTimeout() method.
              clearTimeout(timeout);
              //if user taps twice in 500ms
              if (tapLength < 500 && tapLength > 0) {
                //hide menu
                contextMenu.style.visibility = "hidden";
                $('.folder-view .item').removeClass('selected')
                e.preventDefault();
              } else {
                //timeout if user doesn't tap after 500ms
                timeout = setTimeout(function () {
                  clearTimeout(timeout);
                }, 500);
              }
              //lastTap set to current time
              lastTap = currentTime;
            });

            //click outside the menu to close it (for click devices)
            document.addEventListener("click", function (e) {
              if (!contextMenu.contains(e.target)) {
                contextMenu.style.visibility = "hidden";
                $('.folder-view .item').removeClass('selected')
                $('#context-menu').html('')
              }
            });

    }
}